import React, { useEffect, useRef, useState } from "react";
import Search from "../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Dropdown, Form, Select, Table } from "antd";
import svg27 from "../../assets/svg/svg27.svg";
import svg12 from "../../assets/svg/svg12.svg";
import svg15 from "../../assets/svg/svg15.svg";
import svg29 from "../../assets/svg/svg29.svg";
import BreadCrumb from "../../layout/BreadCrumb";
import CardLoading from "../../components/CardLoading";
import { Link, useNavigate } from "react-router-dom";
import { fetchData } from "../../features/fetch/fetchSlice";
import { setActiveObj } from "../../features/obj/objSlice";
import { formatText } from "../../utils";
import StateAgencyView from "./StateAgencyView";
import useModalToggle from "../../custom_hooks/useModalToggle";
import moment from "moment";

function StateAgencyTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const url = "api/v2/stateAgency/get";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));

  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");

  const { open, handleCancel, handleOpen } = useModalToggle();
  const [openDrawer, setOpenDrawer] = useState(false);
  const showDrawer = () => {
    setOpenDrawer(true);
  };
  const onClose = () => {
    setOpenDrawer(false);
  };

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: "api/v2/stateAgency/get",
        agencyName: e.target.value == "" ? null : e.target.value,
      })
    );
  };

  const handleEdit = async () => {
    await dispatch(setActiveObj({ key: "stateAgency", data: prodd }));
    await navigate("/state-agency-add");
  };
  const handleDisable = () => {};
  const handleAdd = async () => {
    await dispatch(setActiveObj({ key: "stateAgency", data: {} }));
    await navigate("/state-agency-add");
  };
  const handleView = async () => {
    await dispatch(setActiveObj({ key: "stateAgency", data: prodd }));
    await showDrawer();
  };
  const handleViewName = async (item) => {
    await dispatch(setActiveObj({ key: "stateAgency", data: item }));
    await showDrawer();
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <div onClick={handleEdit}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4 ">
            <img src={svg12} alt="svg12" /> Edit
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div onClick={handleView}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4 ">
            <img src={svg15} alt="svg15" /> View
          </Link>
        </div>
      ),
    },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Institution",
      render: (item) => {
        return (
          <div className="cursor-pointer" onClick={() => handleViewName(item)}>
            {item?.agencyName}
          </div>
        );
      },
      sorter: (a, b) => a.agencyName.localeCompare(b.agencyName),
    },

    {
      title: "Location",
      dataIndex: "agencyPhysicalLocation",
      sorter: (a, b) =>
        a.agencyPhysicalLocation.localeCompare(b.agencyPhysicalLocation),
    },
    {
      title: "MD/CEO",
      dataIndex: "agencyMdOrCeoName",
      sorter: (a, b) => a.agencyMdOrCeoName.localeCompare(b.agencyMdOrCeoName),
    },
    {
      title: "Admin Phone",
      dataIndex: "agencyContactPersonPhone",
      sorter: (a, b) =>
        a.agencyContactPersonPhone.localeCompare(b.agencyContactPersonPhone),
    },
    {
      title: "Date Registered",
      dataIndex: "createdDate",
      render: (text) =>
        text ? moment(text).format("DD-MM-YYYY") : "--",
      sorter: (a, b) =>
        moment(a.createdDate).valueOf() -
        moment(b.createdDate).valueOf(),
    },
    {
      title: "Status",
      dataIndex: "agencyStatus",
      render: (item) => {
        const colors = {
          ACTIVE: "#28A745",
          PENDING_APPROVAL: "#3250FF",
          INACTIVE: "#F44336",
        };

        return (
          <div
            className="text-[#FFF] inline-block rounded-[8px] px-[8px] py-[4px] w-auto !text-[12px]"
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {formatText(item)}
          </div>
        );
      },
    },

    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const onFinish = () => {};

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchAgencyData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    fetchAgencyData();
  }, []);

  if (loading && !searchInput) return <CardLoading />;
  return (
    <div className="lg:min-h-[88vh] flex flex-col">
      <BreadCrumb breadcrumbs={[{ title: "State Agency" }]} />
      <div className="flex flex-col w-full  flex-1  white_card mt-[1.25rem]">
        <div className="flex items-center justify-between  gap-y-4">
          <div className="form-add-h">State Agencies</div>
        </div>

        <div className="flex lg:flex-row flex-col gap-y-2 items-center mt-[1.75rem] justify-between">
          <div className="lg:w-[29.1875rem] w-full">
            <Search
              searchInput={searchInput}
              handleSearch={handleSearch}
              text={"Search"}
            />
          </div>
          <div className="w-[200px]">
            <button onClick={() => handleAdd()} className="cstm-btn-2">
              <img src={svg29} alt="svg29" />
              <span className="">New State Agency</span>
            </button>
          </div>
        </div>

        <div className="max-w-full w-full overflow-x-auto">
          <Table
            rowSelection={false}
            className="mt-[1.75rem] w-full"
            scroll={{
              x: 'max-content',
            }}
            rowKey={(record) => record?.agencyId}
            columns={columns}
            dataSource={data}
            loading={loading}
            pagination={{
              position: ["bottomRight"],
              current: pageIndex + 1,
              total: count,
              pageSize: pageSize,
              onChange: (page, size) => {
                setPageIndex(page - 1);
                setPageSize(size);
                fetchAgencyData(page - 1, size);
              },
              showSizeChanger: false,
              hideOnSinglePage: true,
            }}
          />
        </div>
      </div>

      <StateAgencyView onClose={onClose} open={openDrawer} prodd={prodd} />
    </div>
  );
}

export default StateAgencyTable;
